// scripts/generate_pdfjs_cmap_urls.mjs で生成。直接編集しない。
// URL を 1 件ずつ静的に書き出しているのは、テンプレートリテラルで動的に組み立てると
// Turbopack が name によらず常に先頭ファイルの URL を返すため。
export const CMAP_URLS: Record<string, string> = {
  '78-EUC-H': new URL('pdfjs-dist/cmaps/78-EUC-H.bcmap', import.meta.url).toString(),
  '78-EUC-V': new URL('pdfjs-dist/cmaps/78-EUC-V.bcmap', import.meta.url).toString(),
  '78-H': new URL('pdfjs-dist/cmaps/78-H.bcmap', import.meta.url).toString(),
  '78-RKSJ-H': new URL('pdfjs-dist/cmaps/78-RKSJ-H.bcmap', import.meta.url).toString(),
  '78-RKSJ-V': new URL('pdfjs-dist/cmaps/78-RKSJ-V.bcmap', import.meta.url).toString(),
  '78-V': new URL('pdfjs-dist/cmaps/78-V.bcmap', import.meta.url).toString(),
  '78ms-RKSJ-H': new URL('pdfjs-dist/cmaps/78ms-RKSJ-H.bcmap', import.meta.url).toString(),
  '78ms-RKSJ-V': new URL('pdfjs-dist/cmaps/78ms-RKSJ-V.bcmap', import.meta.url).toString(),
  '83pv-RKSJ-H': new URL('pdfjs-dist/cmaps/83pv-RKSJ-H.bcmap', import.meta.url).toString(),
  '90ms-RKSJ-H': new URL('pdfjs-dist/cmaps/90ms-RKSJ-H.bcmap', import.meta.url).toString(),
  '90ms-RKSJ-V': new URL('pdfjs-dist/cmaps/90ms-RKSJ-V.bcmap', import.meta.url).toString(),
  '90msp-RKSJ-H': new URL('pdfjs-dist/cmaps/90msp-RKSJ-H.bcmap', import.meta.url).toString(),
  '90msp-RKSJ-V': new URL('pdfjs-dist/cmaps/90msp-RKSJ-V.bcmap', import.meta.url).toString(),
  '90pv-RKSJ-H': new URL('pdfjs-dist/cmaps/90pv-RKSJ-H.bcmap', import.meta.url).toString(),
  '90pv-RKSJ-V': new URL('pdfjs-dist/cmaps/90pv-RKSJ-V.bcmap', import.meta.url).toString(),
  'Add-H': new URL('pdfjs-dist/cmaps/Add-H.bcmap', import.meta.url).toString(),
  'Add-RKSJ-H': new URL('pdfjs-dist/cmaps/Add-RKSJ-H.bcmap', import.meta.url).toString(),
  'Add-RKSJ-V': new URL('pdfjs-dist/cmaps/Add-RKSJ-V.bcmap', import.meta.url).toString(),
  'Add-V': new URL('pdfjs-dist/cmaps/Add-V.bcmap', import.meta.url).toString(),
  'Adobe-CNS1-0': new URL('pdfjs-dist/cmaps/Adobe-CNS1-0.bcmap', import.meta.url).toString(),
  'Adobe-CNS1-1': new URL('pdfjs-dist/cmaps/Adobe-CNS1-1.bcmap', import.meta.url).toString(),
  'Adobe-CNS1-2': new URL('pdfjs-dist/cmaps/Adobe-CNS1-2.bcmap', import.meta.url).toString(),
  'Adobe-CNS1-3': new URL('pdfjs-dist/cmaps/Adobe-CNS1-3.bcmap', import.meta.url).toString(),
  'Adobe-CNS1-4': new URL('pdfjs-dist/cmaps/Adobe-CNS1-4.bcmap', import.meta.url).toString(),
  'Adobe-CNS1-5': new URL('pdfjs-dist/cmaps/Adobe-CNS1-5.bcmap', import.meta.url).toString(),
  'Adobe-CNS1-6': new URL('pdfjs-dist/cmaps/Adobe-CNS1-6.bcmap', import.meta.url).toString(),
  'Adobe-CNS1-UCS2': new URL('pdfjs-dist/cmaps/Adobe-CNS1-UCS2.bcmap', import.meta.url).toString(),
  'Adobe-GB1-0': new URL('pdfjs-dist/cmaps/Adobe-GB1-0.bcmap', import.meta.url).toString(),
  'Adobe-GB1-1': new URL('pdfjs-dist/cmaps/Adobe-GB1-1.bcmap', import.meta.url).toString(),
  'Adobe-GB1-2': new URL('pdfjs-dist/cmaps/Adobe-GB1-2.bcmap', import.meta.url).toString(),
  'Adobe-GB1-3': new URL('pdfjs-dist/cmaps/Adobe-GB1-3.bcmap', import.meta.url).toString(),
  'Adobe-GB1-4': new URL('pdfjs-dist/cmaps/Adobe-GB1-4.bcmap', import.meta.url).toString(),
  'Adobe-GB1-5': new URL('pdfjs-dist/cmaps/Adobe-GB1-5.bcmap', import.meta.url).toString(),
  'Adobe-GB1-UCS2': new URL('pdfjs-dist/cmaps/Adobe-GB1-UCS2.bcmap', import.meta.url).toString(),
  'Adobe-Japan1-0': new URL('pdfjs-dist/cmaps/Adobe-Japan1-0.bcmap', import.meta.url).toString(),
  'Adobe-Japan1-1': new URL('pdfjs-dist/cmaps/Adobe-Japan1-1.bcmap', import.meta.url).toString(),
  'Adobe-Japan1-2': new URL('pdfjs-dist/cmaps/Adobe-Japan1-2.bcmap', import.meta.url).toString(),
  'Adobe-Japan1-3': new URL('pdfjs-dist/cmaps/Adobe-Japan1-3.bcmap', import.meta.url).toString(),
  'Adobe-Japan1-4': new URL('pdfjs-dist/cmaps/Adobe-Japan1-4.bcmap', import.meta.url).toString(),
  'Adobe-Japan1-5': new URL('pdfjs-dist/cmaps/Adobe-Japan1-5.bcmap', import.meta.url).toString(),
  'Adobe-Japan1-6': new URL('pdfjs-dist/cmaps/Adobe-Japan1-6.bcmap', import.meta.url).toString(),
  'Adobe-Japan1-UCS2': new URL(
    'pdfjs-dist/cmaps/Adobe-Japan1-UCS2.bcmap',
    import.meta.url,
  ).toString(),
  'Adobe-Korea1-0': new URL('pdfjs-dist/cmaps/Adobe-Korea1-0.bcmap', import.meta.url).toString(),
  'Adobe-Korea1-1': new URL('pdfjs-dist/cmaps/Adobe-Korea1-1.bcmap', import.meta.url).toString(),
  'Adobe-Korea1-2': new URL('pdfjs-dist/cmaps/Adobe-Korea1-2.bcmap', import.meta.url).toString(),
  'Adobe-Korea1-UCS2': new URL(
    'pdfjs-dist/cmaps/Adobe-Korea1-UCS2.bcmap',
    import.meta.url,
  ).toString(),
  'B5-H': new URL('pdfjs-dist/cmaps/B5-H.bcmap', import.meta.url).toString(),
  'B5-V': new URL('pdfjs-dist/cmaps/B5-V.bcmap', import.meta.url).toString(),
  'B5pc-H': new URL('pdfjs-dist/cmaps/B5pc-H.bcmap', import.meta.url).toString(),
  'B5pc-V': new URL('pdfjs-dist/cmaps/B5pc-V.bcmap', import.meta.url).toString(),
  'CNS-EUC-H': new URL('pdfjs-dist/cmaps/CNS-EUC-H.bcmap', import.meta.url).toString(),
  'CNS-EUC-V': new URL('pdfjs-dist/cmaps/CNS-EUC-V.bcmap', import.meta.url).toString(),
  'CNS1-H': new URL('pdfjs-dist/cmaps/CNS1-H.bcmap', import.meta.url).toString(),
  'CNS1-V': new URL('pdfjs-dist/cmaps/CNS1-V.bcmap', import.meta.url).toString(),
  'CNS2-H': new URL('pdfjs-dist/cmaps/CNS2-H.bcmap', import.meta.url).toString(),
  'CNS2-V': new URL('pdfjs-dist/cmaps/CNS2-V.bcmap', import.meta.url).toString(),
  'ETHK-B5-H': new URL('pdfjs-dist/cmaps/ETHK-B5-H.bcmap', import.meta.url).toString(),
  'ETHK-B5-V': new URL('pdfjs-dist/cmaps/ETHK-B5-V.bcmap', import.meta.url).toString(),
  'ETen-B5-H': new URL('pdfjs-dist/cmaps/ETen-B5-H.bcmap', import.meta.url).toString(),
  'ETen-B5-V': new URL('pdfjs-dist/cmaps/ETen-B5-V.bcmap', import.meta.url).toString(),
  'ETenms-B5-H': new URL('pdfjs-dist/cmaps/ETenms-B5-H.bcmap', import.meta.url).toString(),
  'ETenms-B5-V': new URL('pdfjs-dist/cmaps/ETenms-B5-V.bcmap', import.meta.url).toString(),
  'EUC-H': new URL('pdfjs-dist/cmaps/EUC-H.bcmap', import.meta.url).toString(),
  'EUC-V': new URL('pdfjs-dist/cmaps/EUC-V.bcmap', import.meta.url).toString(),
  'Ext-H': new URL('pdfjs-dist/cmaps/Ext-H.bcmap', import.meta.url).toString(),
  'Ext-RKSJ-H': new URL('pdfjs-dist/cmaps/Ext-RKSJ-H.bcmap', import.meta.url).toString(),
  'Ext-RKSJ-V': new URL('pdfjs-dist/cmaps/Ext-RKSJ-V.bcmap', import.meta.url).toString(),
  'Ext-V': new URL('pdfjs-dist/cmaps/Ext-V.bcmap', import.meta.url).toString(),
  'GB-EUC-H': new URL('pdfjs-dist/cmaps/GB-EUC-H.bcmap', import.meta.url).toString(),
  'GB-EUC-V': new URL('pdfjs-dist/cmaps/GB-EUC-V.bcmap', import.meta.url).toString(),
  'GB-H': new URL('pdfjs-dist/cmaps/GB-H.bcmap', import.meta.url).toString(),
  'GB-V': new URL('pdfjs-dist/cmaps/GB-V.bcmap', import.meta.url).toString(),
  'GBK-EUC-H': new URL('pdfjs-dist/cmaps/GBK-EUC-H.bcmap', import.meta.url).toString(),
  'GBK-EUC-V': new URL('pdfjs-dist/cmaps/GBK-EUC-V.bcmap', import.meta.url).toString(),
  'GBK2K-H': new URL('pdfjs-dist/cmaps/GBK2K-H.bcmap', import.meta.url).toString(),
  'GBK2K-V': new URL('pdfjs-dist/cmaps/GBK2K-V.bcmap', import.meta.url).toString(),
  'GBKp-EUC-H': new URL('pdfjs-dist/cmaps/GBKp-EUC-H.bcmap', import.meta.url).toString(),
  'GBKp-EUC-V': new URL('pdfjs-dist/cmaps/GBKp-EUC-V.bcmap', import.meta.url).toString(),
  'GBT-EUC-H': new URL('pdfjs-dist/cmaps/GBT-EUC-H.bcmap', import.meta.url).toString(),
  'GBT-EUC-V': new URL('pdfjs-dist/cmaps/GBT-EUC-V.bcmap', import.meta.url).toString(),
  'GBT-H': new URL('pdfjs-dist/cmaps/GBT-H.bcmap', import.meta.url).toString(),
  'GBT-V': new URL('pdfjs-dist/cmaps/GBT-V.bcmap', import.meta.url).toString(),
  'GBTpc-EUC-H': new URL('pdfjs-dist/cmaps/GBTpc-EUC-H.bcmap', import.meta.url).toString(),
  'GBTpc-EUC-V': new URL('pdfjs-dist/cmaps/GBTpc-EUC-V.bcmap', import.meta.url).toString(),
  'GBpc-EUC-H': new URL('pdfjs-dist/cmaps/GBpc-EUC-H.bcmap', import.meta.url).toString(),
  'GBpc-EUC-V': new URL('pdfjs-dist/cmaps/GBpc-EUC-V.bcmap', import.meta.url).toString(),
  H: new URL('pdfjs-dist/cmaps/H.bcmap', import.meta.url).toString(),
  'HKdla-B5-H': new URL('pdfjs-dist/cmaps/HKdla-B5-H.bcmap', import.meta.url).toString(),
  'HKdla-B5-V': new URL('pdfjs-dist/cmaps/HKdla-B5-V.bcmap', import.meta.url).toString(),
  'HKdlb-B5-H': new URL('pdfjs-dist/cmaps/HKdlb-B5-H.bcmap', import.meta.url).toString(),
  'HKdlb-B5-V': new URL('pdfjs-dist/cmaps/HKdlb-B5-V.bcmap', import.meta.url).toString(),
  'HKgccs-B5-H': new URL('pdfjs-dist/cmaps/HKgccs-B5-H.bcmap', import.meta.url).toString(),
  'HKgccs-B5-V': new URL('pdfjs-dist/cmaps/HKgccs-B5-V.bcmap', import.meta.url).toString(),
  'HKm314-B5-H': new URL('pdfjs-dist/cmaps/HKm314-B5-H.bcmap', import.meta.url).toString(),
  'HKm314-B5-V': new URL('pdfjs-dist/cmaps/HKm314-B5-V.bcmap', import.meta.url).toString(),
  'HKm471-B5-H': new URL('pdfjs-dist/cmaps/HKm471-B5-H.bcmap', import.meta.url).toString(),
  'HKm471-B5-V': new URL('pdfjs-dist/cmaps/HKm471-B5-V.bcmap', import.meta.url).toString(),
  'HKscs-B5-H': new URL('pdfjs-dist/cmaps/HKscs-B5-H.bcmap', import.meta.url).toString(),
  'HKscs-B5-V': new URL('pdfjs-dist/cmaps/HKscs-B5-V.bcmap', import.meta.url).toString(),
  Hankaku: new URL('pdfjs-dist/cmaps/Hankaku.bcmap', import.meta.url).toString(),
  Hiragana: new URL('pdfjs-dist/cmaps/Hiragana.bcmap', import.meta.url).toString(),
  'KSC-EUC-H': new URL('pdfjs-dist/cmaps/KSC-EUC-H.bcmap', import.meta.url).toString(),
  'KSC-EUC-V': new URL('pdfjs-dist/cmaps/KSC-EUC-V.bcmap', import.meta.url).toString(),
  'KSC-H': new URL('pdfjs-dist/cmaps/KSC-H.bcmap', import.meta.url).toString(),
  'KSC-Johab-H': new URL('pdfjs-dist/cmaps/KSC-Johab-H.bcmap', import.meta.url).toString(),
  'KSC-Johab-V': new URL('pdfjs-dist/cmaps/KSC-Johab-V.bcmap', import.meta.url).toString(),
  'KSC-V': new URL('pdfjs-dist/cmaps/KSC-V.bcmap', import.meta.url).toString(),
  'KSCms-UHC-H': new URL('pdfjs-dist/cmaps/KSCms-UHC-H.bcmap', import.meta.url).toString(),
  'KSCms-UHC-HW-H': new URL('pdfjs-dist/cmaps/KSCms-UHC-HW-H.bcmap', import.meta.url).toString(),
  'KSCms-UHC-HW-V': new URL('pdfjs-dist/cmaps/KSCms-UHC-HW-V.bcmap', import.meta.url).toString(),
  'KSCms-UHC-V': new URL('pdfjs-dist/cmaps/KSCms-UHC-V.bcmap', import.meta.url).toString(),
  'KSCpc-EUC-H': new URL('pdfjs-dist/cmaps/KSCpc-EUC-H.bcmap', import.meta.url).toString(),
  'KSCpc-EUC-V': new URL('pdfjs-dist/cmaps/KSCpc-EUC-V.bcmap', import.meta.url).toString(),
  Katakana: new URL('pdfjs-dist/cmaps/Katakana.bcmap', import.meta.url).toString(),
  'NWP-H': new URL('pdfjs-dist/cmaps/NWP-H.bcmap', import.meta.url).toString(),
  'NWP-V': new URL('pdfjs-dist/cmaps/NWP-V.bcmap', import.meta.url).toString(),
  'RKSJ-H': new URL('pdfjs-dist/cmaps/RKSJ-H.bcmap', import.meta.url).toString(),
  'RKSJ-V': new URL('pdfjs-dist/cmaps/RKSJ-V.bcmap', import.meta.url).toString(),
  Roman: new URL('pdfjs-dist/cmaps/Roman.bcmap', import.meta.url).toString(),
  'UniCNS-UCS2-H': new URL('pdfjs-dist/cmaps/UniCNS-UCS2-H.bcmap', import.meta.url).toString(),
  'UniCNS-UCS2-V': new URL('pdfjs-dist/cmaps/UniCNS-UCS2-V.bcmap', import.meta.url).toString(),
  'UniCNS-UTF16-H': new URL('pdfjs-dist/cmaps/UniCNS-UTF16-H.bcmap', import.meta.url).toString(),
  'UniCNS-UTF16-V': new URL('pdfjs-dist/cmaps/UniCNS-UTF16-V.bcmap', import.meta.url).toString(),
  'UniCNS-UTF32-H': new URL('pdfjs-dist/cmaps/UniCNS-UTF32-H.bcmap', import.meta.url).toString(),
  'UniCNS-UTF32-V': new URL('pdfjs-dist/cmaps/UniCNS-UTF32-V.bcmap', import.meta.url).toString(),
  'UniCNS-UTF8-H': new URL('pdfjs-dist/cmaps/UniCNS-UTF8-H.bcmap', import.meta.url).toString(),
  'UniCNS-UTF8-V': new URL('pdfjs-dist/cmaps/UniCNS-UTF8-V.bcmap', import.meta.url).toString(),
  'UniGB-UCS2-H': new URL('pdfjs-dist/cmaps/UniGB-UCS2-H.bcmap', import.meta.url).toString(),
  'UniGB-UCS2-V': new URL('pdfjs-dist/cmaps/UniGB-UCS2-V.bcmap', import.meta.url).toString(),
  'UniGB-UTF16-H': new URL('pdfjs-dist/cmaps/UniGB-UTF16-H.bcmap', import.meta.url).toString(),
  'UniGB-UTF16-V': new URL('pdfjs-dist/cmaps/UniGB-UTF16-V.bcmap', import.meta.url).toString(),
  'UniGB-UTF32-H': new URL('pdfjs-dist/cmaps/UniGB-UTF32-H.bcmap', import.meta.url).toString(),
  'UniGB-UTF32-V': new URL('pdfjs-dist/cmaps/UniGB-UTF32-V.bcmap', import.meta.url).toString(),
  'UniGB-UTF8-H': new URL('pdfjs-dist/cmaps/UniGB-UTF8-H.bcmap', import.meta.url).toString(),
  'UniGB-UTF8-V': new URL('pdfjs-dist/cmaps/UniGB-UTF8-V.bcmap', import.meta.url).toString(),
  'UniJIS-UCS2-H': new URL('pdfjs-dist/cmaps/UniJIS-UCS2-H.bcmap', import.meta.url).toString(),
  'UniJIS-UCS2-HW-H': new URL(
    'pdfjs-dist/cmaps/UniJIS-UCS2-HW-H.bcmap',
    import.meta.url,
  ).toString(),
  'UniJIS-UCS2-HW-V': new URL(
    'pdfjs-dist/cmaps/UniJIS-UCS2-HW-V.bcmap',
    import.meta.url,
  ).toString(),
  'UniJIS-UCS2-V': new URL('pdfjs-dist/cmaps/UniJIS-UCS2-V.bcmap', import.meta.url).toString(),
  'UniJIS-UTF16-H': new URL('pdfjs-dist/cmaps/UniJIS-UTF16-H.bcmap', import.meta.url).toString(),
  'UniJIS-UTF16-V': new URL('pdfjs-dist/cmaps/UniJIS-UTF16-V.bcmap', import.meta.url).toString(),
  'UniJIS-UTF32-H': new URL('pdfjs-dist/cmaps/UniJIS-UTF32-H.bcmap', import.meta.url).toString(),
  'UniJIS-UTF32-V': new URL('pdfjs-dist/cmaps/UniJIS-UTF32-V.bcmap', import.meta.url).toString(),
  'UniJIS-UTF8-H': new URL('pdfjs-dist/cmaps/UniJIS-UTF8-H.bcmap', import.meta.url).toString(),
  'UniJIS-UTF8-V': new URL('pdfjs-dist/cmaps/UniJIS-UTF8-V.bcmap', import.meta.url).toString(),
  'UniJIS2004-UTF16-H': new URL(
    'pdfjs-dist/cmaps/UniJIS2004-UTF16-H.bcmap',
    import.meta.url,
  ).toString(),
  'UniJIS2004-UTF16-V': new URL(
    'pdfjs-dist/cmaps/UniJIS2004-UTF16-V.bcmap',
    import.meta.url,
  ).toString(),
  'UniJIS2004-UTF32-H': new URL(
    'pdfjs-dist/cmaps/UniJIS2004-UTF32-H.bcmap',
    import.meta.url,
  ).toString(),
  'UniJIS2004-UTF32-V': new URL(
    'pdfjs-dist/cmaps/UniJIS2004-UTF32-V.bcmap',
    import.meta.url,
  ).toString(),
  'UniJIS2004-UTF8-H': new URL(
    'pdfjs-dist/cmaps/UniJIS2004-UTF8-H.bcmap',
    import.meta.url,
  ).toString(),
  'UniJIS2004-UTF8-V': new URL(
    'pdfjs-dist/cmaps/UniJIS2004-UTF8-V.bcmap',
    import.meta.url,
  ).toString(),
  'UniJISPro-UCS2-HW-V': new URL(
    'pdfjs-dist/cmaps/UniJISPro-UCS2-HW-V.bcmap',
    import.meta.url,
  ).toString(),
  'UniJISPro-UCS2-V': new URL(
    'pdfjs-dist/cmaps/UniJISPro-UCS2-V.bcmap',
    import.meta.url,
  ).toString(),
  'UniJISPro-UTF8-V': new URL(
    'pdfjs-dist/cmaps/UniJISPro-UTF8-V.bcmap',
    import.meta.url,
  ).toString(),
  'UniJISX0213-UTF32-H': new URL(
    'pdfjs-dist/cmaps/UniJISX0213-UTF32-H.bcmap',
    import.meta.url,
  ).toString(),
  'UniJISX0213-UTF32-V': new URL(
    'pdfjs-dist/cmaps/UniJISX0213-UTF32-V.bcmap',
    import.meta.url,
  ).toString(),
  'UniJISX02132004-UTF32-H': new URL(
    'pdfjs-dist/cmaps/UniJISX02132004-UTF32-H.bcmap',
    import.meta.url,
  ).toString(),
  'UniJISX02132004-UTF32-V': new URL(
    'pdfjs-dist/cmaps/UniJISX02132004-UTF32-V.bcmap',
    import.meta.url,
  ).toString(),
  'UniKS-UCS2-H': new URL('pdfjs-dist/cmaps/UniKS-UCS2-H.bcmap', import.meta.url).toString(),
  'UniKS-UCS2-V': new URL('pdfjs-dist/cmaps/UniKS-UCS2-V.bcmap', import.meta.url).toString(),
  'UniKS-UTF16-H': new URL('pdfjs-dist/cmaps/UniKS-UTF16-H.bcmap', import.meta.url).toString(),
  'UniKS-UTF16-V': new URL('pdfjs-dist/cmaps/UniKS-UTF16-V.bcmap', import.meta.url).toString(),
  'UniKS-UTF32-H': new URL('pdfjs-dist/cmaps/UniKS-UTF32-H.bcmap', import.meta.url).toString(),
  'UniKS-UTF32-V': new URL('pdfjs-dist/cmaps/UniKS-UTF32-V.bcmap', import.meta.url).toString(),
  'UniKS-UTF8-H': new URL('pdfjs-dist/cmaps/UniKS-UTF8-H.bcmap', import.meta.url).toString(),
  'UniKS-UTF8-V': new URL('pdfjs-dist/cmaps/UniKS-UTF8-V.bcmap', import.meta.url).toString(),
  V: new URL('pdfjs-dist/cmaps/V.bcmap', import.meta.url).toString(),
  'WP-Symbol': new URL('pdfjs-dist/cmaps/WP-Symbol.bcmap', import.meta.url).toString(),
};
